<scaffold-dialog [title]="data.title" [fit]="true">
  <div scaffoldDialogBody>
    <p>{{data.message}}</p>
  </div>
  <div scaffoldDialogButtons>
      <button pButton severity="secondary" (click)="onNoClick()">{{'cancel'| translation}}</button>
      <span>
        <button style="margin-right: 8px;" pButton severity="secondary" (click)="onYesClick()">{{'discard'| translation}}</button>
        <button pButton severity="primary" cdkFocusInitial (click)="onYesClick(true)">{{'save'| translation}}</button>
      </span>
  </div>

</scaffold-dialog>
